namespace RioERP.Reports {
    export interface OrderTransactionReportRow {
        SrId?: number;
        Id?: number;
        CustomerId?: number;
        OrderNumber?: string;
        CustomerName?: string;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        BillingAddress1?: string;
        BillingAddress2?: string;
        BillingCity?: string;
        BillingStateId?: number;
        BillingPincode?: number;
        ShippingToName?: string;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingStateId?: number;
        ShippingPincode?: number;
        EOrderStatus?: number;
        EShippingType?: number;
        DiscountPer?: number;
        OrderDate?: string;
        ESourceType?: Web.Enums.SourceType;
        SourceName?: string;
        EmailSendCount?: number;
        IsEmailSent?: boolean;
        EPaymentStatus?: number;
        LastEmailSentDate?: string;
        FranchiseeId?: number;
        EOrderProcessBy?: number;
        DiscountCoupon?: string;
        DiscountAmount?: number;
        GrossAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        EShippingStatus?: number;
        EInvoiceStatus?: number;
        MailId?: number;
        EPaymentType?: number;
        Gstin?: string;
        ExpectedShippingDate?: string;
        EInvoiceTo?: number;
        EFranchiseeDiscountType?: number;
        EFranchiseeDiscount?: number;
        FranchiseeDiscountValue?: number;
        FranchiseeDiscountAmount?: number;
        InvoiceCompanyId?: number;
        ShippingNote?: string;
        SourceOrderNumber?: string;
        IsActive?: boolean;
        VendorId?: number;
        TaxAmount?: number;
        FreezeData?: boolean;
        ShippingProviderId?: number;
        CurrencyId?: number;
        CurrencyAmount?: number;
        NetAmountAfterFrDiscount?: number;
        BillingCountry?: string;
        ShippingCountry?: string;
        Mode?: number;
        TransactionId?: string;
        PaymentMode?: Web.Enums.PaymentMode;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderTransactionReportRow {
        export const idProperty = 'SrId';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.OrderTransactionReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SrId = "SrId",
            Id = "Id",
            CustomerId = "CustomerId",
            OrderNumber = "OrderNumber",
            CustomerName = "CustomerName",
            CustomerEmail1 = "CustomerEmail1",
            CustomerEmail2 = "CustomerEmail2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            BillingAddress1 = "BillingAddress1",
            BillingAddress2 = "BillingAddress2",
            BillingCity = "BillingCity",
            BillingStateId = "BillingStateId",
            BillingPincode = "BillingPincode",
            ShippingToName = "ShippingToName",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingStateId = "ShippingStateId",
            ShippingPincode = "ShippingPincode",
            EOrderStatus = "EOrderStatus",
            EShippingType = "EShippingType",
            DiscountPer = "DiscountPer",
            OrderDate = "OrderDate",
            ESourceType = "ESourceType",
            SourceName = "SourceName",
            EmailSendCount = "EmailSendCount",
            IsEmailSent = "IsEmailSent",
            EPaymentStatus = "EPaymentStatus",
            LastEmailSentDate = "LastEmailSentDate",
            FranchiseeId = "FranchiseeId",
            EOrderProcessBy = "EOrderProcessBy",
            DiscountCoupon = "DiscountCoupon",
            DiscountAmount = "DiscountAmount",
            GrossAmount = "GrossAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            EShippingStatus = "EShippingStatus",
            EInvoiceStatus = "EInvoiceStatus",
            MailId = "MailId",
            EPaymentType = "EPaymentType",
            Gstin = "Gstin",
            ExpectedShippingDate = "ExpectedShippingDate",
            EInvoiceTo = "EInvoiceTo",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EFranchiseeDiscount = "EFranchiseeDiscount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            InvoiceCompanyId = "InvoiceCompanyId",
            ShippingNote = "ShippingNote",
            SourceOrderNumber = "SourceOrderNumber",
            IsActive = "IsActive",
            VendorId = "VendorId",
            TaxAmount = "TaxAmount",
            FreezeData = "FreezeData",
            ShippingProviderId = "ShippingProviderId",
            CurrencyId = "CurrencyId",
            CurrencyAmount = "CurrencyAmount",
            NetAmountAfterFrDiscount = "NetAmountAfterFrDiscount",
            BillingCountry = "BillingCountry",
            ShippingCountry = "ShippingCountry",
            Mode = "Mode",
            TransactionId = "TransactionId",
            PaymentMode = "PaymentMode",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
